import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc constant
     * @name APP_MEMORY_STORAGE_KEY
     * @memberof app
     *
     * @description
     * Some backend service responses are are kept in storage to have quick access to them without further requesting
     * the backend.
     *
     * @author flzemke.btc
     */
    angular.module('app').constant('APP_MEMORY_STORAGE_KEY', {
        PLATFORM_SETTINGS: 'app_mem_platform_settings'
    });
})();
